/* Campaigns and store navigation. Native Shopify forms own the purchase flow. */
// Referral links (?ref=<customer id>-<signature>) are remembered for 30 days and passed to the order as the hidden cart attribute _ms_referral.
(() => {
  const key = 'ms-referral';
  const valid = code => /^\d{6,16}-[0-9a-f]{8}$/.test(code || '');
  let stored = null;
  try { stored = JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) {}
  const incoming = new URL(location.href).searchParams.get('ref');
  if (valid(incoming)) {
    stored = { code: incoming, at: Date.now() };
    try { localStorage.setItem(key, JSON.stringify(stored)); } catch (_) {}
  }
  if (!stored || !valid(stored.code) || Date.now() - stored.at > 30 * 864e5) return;
  try { if (sessionStorage.getItem(key) === stored.code) return; } catch (_) {}
  fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _ms_referral: stored.code } }) })
    .then(response => { if (response.ok) try { sessionStorage.setItem(key, stored.code); } catch (_) {} })
    .catch(() => {});
})();
(() => {
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  // The club invitation is shown at most once every 60 days per browser and never again after joining.
  const inviteKey = 'ms-club-invite';
  const inviteDays = 60;
  const remember = (joined = false) => {
    try { sessionStorage.setItem('ms-club-dismissed', '1'); } catch (_) {}
    try { if (joined || localStorage.getItem(inviteKey) !== 'joined') localStorage.setItem(inviteKey, joined ? 'joined' : String(Date.now())); } catch (_) {}
  };
  const dismissed = () => {
    try { if (sessionStorage.getItem('ms-club-dismissed') === '1') return true; } catch (_) {}
    try {
      const value = localStorage.getItem(inviteKey);
      return value === 'joined' || (Boolean(value) && Date.now() - Number(value) < inviteDays * 864e5);
    } catch (_) { return false; }
  };
  const openDialog = dialog => {
    if (!dialog || dialog.open) return;
    document.querySelectorAll('dialog[data-store-dialog][open]').forEach(other => other.close());
    dialog.showModal();
    const video = dialog.querySelector('video');
    if (video) video.play().catch(() => {});
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener) { if(opener.dataset.openDialog === 'SleepTest') remember(); event.preventDefault(); openDialog(document.getElementById(opener.dataset.openDialog)); }
    const newsletter = event.target.closest('[data-newsletter-open]');
    if (newsletter && document.querySelector('[data-newsletter-dialog]')) {
      event.preventDefault(); remember(); openDialog(document.querySelector('[data-newsletter-dialog]'));
    }
    const closer = event.target.closest('[data-close-dialog]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.closest('.ms-menu-dialog a')) event.target.closest('dialog')?.close();
  });

  function init(root = document) {
    root.querySelectorAll('.ms-language-form').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', () => {
        const returnTo = form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
      });
    });
    root.querySelectorAll('[data-store-dialog]').forEach(dialog => {
      if (dialog.dataset.storeInitialized) return;
      dialog.dataset.storeInitialized = 'true';
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        dialog.querySelectorAll('video').forEach(video => video.pause());
        if (dialog.hasAttribute('data-newsletter-dialog')) remember();
      });
    });
    root.querySelectorAll('[data-ms-carousel]').forEach(carousel => {
      if (carousel.dataset.storeInitialized) return;
      carousel.dataset.storeInitialized = 'true';
      const track = carousel.querySelector('[data-carousel-track]');
      const slides = [...track.querySelectorAll('[data-carousel-slide]')];
      const shelf = carousel.dataset.carouselKind === 'shelf';
      const bars = [...carousel.querySelectorAll('[data-carousel-index]')];
      let selected = 0;
      let frame = 0;
      if (!slides.length) return;
      const position = slide => slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - (track.clientWidth - slide.clientWidth) / 2;
      const sync = () => {
        const overflowing = track.scrollWidth > track.clientWidth + 4;
        selected = slides.reduce((closest, slide, index) => Math.abs(position(slide) - track.scrollLeft) < Math.abs(position(slides[closest]) - track.scrollLeft) ? index : closest, 0);
        bars.forEach((bar, i) => bar.setAttribute('aria-current', String(i === selected)));
        if (!shelf) slides.forEach((slide, i) => { slide.inert = i !== selected; });
        const counter = carousel.querySelector('[data-carousel-count]');
        if (counter) counter.textContent = `${String(selected + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
        const controls = carousel.querySelector('.ms-shelf-controls');
        if (controls) controls.hidden = !overflowing;
        if (shelf) {
          carousel.querySelector('[data-carousel-prev]').disabled = track.scrollLeft <= 2;
          carousel.querySelector('[data-carousel-next]').disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        }
      };
      const show = index => {
        const target = shelf ? Math.max(0, Math.min(slides.length - 1, index)) : (index + slides.length) % slides.length;
        track.scrollTo({left: position(slides[target]), behavior: reducedMotion() ? 'instant' : 'smooth'});
      };
      carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => show(selected - 1));
      carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(selected + 1));
      bars.forEach((bar, i) => bar.addEventListener('click', () => show(i)));
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(selected + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); }, {passive: true});
      const observer = new ResizeObserver(sync);
      observer.observe(track);
      carousel.addEventListener('shopify:block:select', event => {
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) show(index);
      });
      const interval = Number(carousel.dataset.carouselAutoplay || 0);
      let autoplay = 0;
      if (!shelf && interval > 0 && slides.length > 1 && !reducedMotion()) {
        const resting = () => document.hidden || carousel.matches(':hover') || carousel.contains(document.activeElement) || document.querySelector('dialog[open]');
        const schedule = () => { clearTimeout(autoplay); autoplay = setTimeout(advance, interval); };
        const advance = () => { if (!resting()) show(selected + 1); schedule(); };
        ['pointerdown', 'keydown', 'pointerleave', 'focusout'].forEach(type => carousel.addEventListener(type, schedule));
        document.addEventListener('visibilitychange', schedule);
        schedule();
      }
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(carousel)) { observer.disconnect(); cancelAnimationFrame(frame); clearTimeout(autoplay); }
      });
      sync();
    });

    const signedUp = document.querySelector('[data-newsletter-complete], [data-club-joined]') || new URL(location.href).searchParams.get('customer_posted') === 'true';
    if (signedUp) remember(true);
    const newsletter = root.querySelector('[data-newsletter-dialog]');
    if (newsletter && !newsletter.dataset.invitationInitialized) {
      newsletter.dataset.invitationInitialized = 'true';
      if (newsletter.querySelector('[data-newsletter-complete], [data-newsletter-error]') && location.hash.includes('NewsletterForm-')) {
        remember(); openDialog(newsletter);
      } else if (newsletter.hasAttribute('data-auto-open') && !dismissed() && document.querySelector('main[data-template="index"]') && !window.Shopify?.designMode) {
        const invite = () => {
          if (dismissed() || !newsletter.isConnected) return;
          const privacyBanner = document.getElementById('shopify-pc__banner');
          const otherDialog = document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]');
          if (document.hidden || otherDialog || privacyBanner?.offsetHeight || document.activeElement?.matches('input, textarea, select')) {
            setTimeout(invite, 2000); return;
          }
          remember(); openDialog(newsletter);
        };
        setTimeout(invite, Number(newsletter.dataset.delay) * 1000);
      }
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
